import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeTheme()
  }

  initializeTheme() {
    const savedTheme = this.getStoredTheme()
    if (savedTheme) {
      this.setTheme(savedTheme)
    } else {
      this.setTheme('light')
    }
  }

  toggle() {
    const currentTheme = this.getCurrentTheme()
    const newTheme = currentTheme === 'light' ? 'dark' : 'light'

    this.setTheme(newTheme)
    this.saveTheme(newTheme)

    // Submit form to update session
    this.submitThemeChange(newTheme)
  }

  setTheme(theme) {
    document.documentElement.setAttribute('data-bs-theme', theme)
  }

  getCurrentTheme() {
    return document.documentElement.getAttribute('data-bs-theme') || 'light'
  }

  getStoredTheme() {
    return localStorage.getItem('smartell-theme')
  }

  saveTheme(theme) {
    localStorage.setItem('smartell-theme', theme)
  }

  submitThemeChange(theme) {
    // Create and submit a form to update the session
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = '/theme/toggle'

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken

    form.appendChild(csrfInput)
    document.body.appendChild(form)
    form.submit()
  }
}
